module.exports = __webpack_public_path__ + "static/media/Lens-Chic_TW.56c625cf.png";